/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import MessengerAlertSuccessView from '../views/MessengerAlertSuccessView';

const defaultConfig = {
  showCloseButton: true,
  hideAfter: 600
};

export default function showSuccessMessage(msgConfig) {
  const config = { ...defaultConfig, ...msgConfig };

  const alertContent = new MessengerAlertSuccessView({
    model: new Backbone.Model({
      title: config.title,
      message: config.message
    })
  }).render().el.outerHTML;

  Messenger().post({
    // id prevents the same message from being shown more than once
    id: config.code,
    message: alertContent,
    type: 'success',
    showCloseButton: config.showCloseButton,
    hideAfter: config.hideAfter
  });
}
